import { render, staticRenderFns } from "./scales_Pop.vue?vue&type=template&id=3cc01176"
import script from "./scales_Pop.vue?vue&type=script&lang=js"
export * from "./scales_Pop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports